import { useState } from 'react';

const NAV_ITEMS = [
  { label: '首页', href: '#hero' },
  { label: '热门话题', href: '#topics' },
  { label: '下载排行', href: '#ranking' },
  { label: '焦点专题', href: '#carousel' },
  { label: '联系我们', href: '#contact' },
];

export default function Header() {
  const [mobileOpen, setMobileOpen] = useState(false);

  const scrollTo = (href: string) => {
    setMobileOpen(false);
    const el = document.querySelector(href);
    if (el) {
      el.scrollIntoView({ behavior: 'smooth' });
    }
  };

  return (
    <header className="fixed top-0 left-0 right-0 z-50 bg-background-50/95 backdrop-blur-md border-b border-background-200/60">
      <div className="w-full px-4 md:px-6">
        <div className="flex items-center justify-between h-16 md:h-20">
          <a href="#hero" onClick={(e) => { e.preventDefault(); scrollTo('#hero'); }} className="flex items-center gap-2 shrink-0 cursor-pointer">
            <div className="w-8 h-8 md:w-9 md:h-9 flex items-center justify-center rounded-lg bg-primary-500">
              <i className="ri-movie-2-line text-white text-base md:text-lg"></i>
            </div>
            <span className="font-heading font-bold text-base md:text-lg text-foreground-900 whitespace-nowrap">91影视看片下载</span>
          </a>

          <nav className="hidden md:flex items-center gap-1">
            {NAV_ITEMS.map((item) => (
              <a
                key={item.href}
                href={item.href}
                onClick={(e) => { e.preventDefault(); scrollTo(item.href); }}
                className="px-4 py-2 text-sm font-medium text-foreground-700 hover:text-primary-600 hover:bg-primary-50 rounded-lg transition-colors cursor-pointer whitespace-nowrap"
              >
                {item.label}
              </a>
            ))}
          </nav>

          <a
            href="#app"
            onClick={(e) => { e.preventDefault(); scrollTo('#app'); }}
            className="hidden md:inline-flex items-center gap-1.5 px-5 py-2.5 bg-primary-500 text-white text-sm font-semibold rounded-lg hover:bg-primary-600 transition-colors cursor-pointer whitespace-nowrap"
          >
            <i className="ri-download-2-line text-base"></i>
            立即下载
          </a>

          <button
            className="md:hidden w-10 h-10 flex items-center justify-center rounded-lg text-foreground-700 hover:bg-background-100 cursor-pointer"
            onClick={() => setMobileOpen(!mobileOpen)}
            aria-label="菜单"
          >
            <i className={`text-xl ${mobileOpen ? 'ri-close-line' : 'ri-menu-line'}`}></i>
          </button>
        </div>
      </div>

      {mobileOpen && (
        <div className="md:hidden border-t border-background-200/60 bg-background-50">
          <nav className="flex flex-col px-4 py-3 gap-1">
            {NAV_ITEMS.map((item) => (
              <a
                key={item.href}
                href={item.href}
                onClick={(e) => { e.preventDefault(); scrollTo(item.href); }}
                className="px-4 py-3 text-sm font-medium text-foreground-700 hover:text-primary-600 hover:bg-primary-50 rounded-lg transition-colors cursor-pointer"
              >
                {item.label}
              </a>
            ))}
            <a
              href="#app"
              onClick={(e) => { e.preventDefault(); scrollTo('#app'); }}
              className="mt-2 px-4 py-3 text-sm font-semibold text-white bg-primary-500 rounded-lg text-center hover:bg-primary-600 transition-colors cursor-pointer"
            >
              <i className="ri-download-2-line mr-1.5"></i>立即下载
            </a>
          </nav>
        </div>
      )}
    </header>
  );
}